import axios from 'axios';
import { getToken, removeToken } from '@/utils/auth';
import router from '@/router';

let axiosInstance = axios.create({
    headers: {'Content-Type': 'application/json'}
})

axiosInstance.interceptors.request.use(
    (config) => {
        let token = getToken();
        
        if (token != undefined) {
            console.log('token = ', token);
            config.headers['Authorization'] = `Bearer ${getToken()}`
        }
        return config;
    },

    // TODO: 了解error判定規則
    (error) => {
        alert('呼叫後端發生錯誤：' + error.message)
        return Promise.reject(error)
    }
);

axiosInstance.interceptors.response.use(
    async (response) => {
        console.log('response = ', response);
        console.log('check type is file = ', (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer'));
        console.log('response data code = 2000 ? ', response.data.code === "2000");
        if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
            const isJson = await response.data.text().then(text => {
                try {
                    JSON.parse(text);
                    return true;
                } catch {
                    return false;
                }
            });

            if (isJson) {
                const errorData = JSON.parse(await response.data.text());
                // alert("错误代码 : " + errorData.code + " 错误讯息 : " + errorData.message);
                return Promise.reject({ code: errorData.code, message: errorData.message});
            } else {
                // 返回正确的blob数据
                return response.data;
            }
        }
        
        if (response.data.code === "2000") {
            return response.data;
        } else { 
            return Promise.reject({ code: response.data.code, message: response.data.message});
        }
    },
    (error) => {
        console.log("error status = ", error.response?.status);
        console.log("error message = ", error.response?.data);

        if (error.response?.status === 400) {
            alert('操作失敗！' + '\n錯誤碼：' + error.response.data.code + '\n錯誤訊息：' + error.response.data.message);
        } else if (error.response?.status === 403) {
            removeToken();
            alert('登入時間已逾時，請重新登入！');
            router.push('/login');
        } else {
            alert('後端回應發生錯誤：' + error);
        }
        return Promise.reject(error);
    }
);


export default axiosInstance